import React from 'react'
import { DataBlock, FlowGrid } from '@fs/zion-ui'
import { getNestedSubelementsByType } from '@fs/zion-sls'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { getFieldValue } from '../utils/utils'
import ReviewDetailsRow from '../../shared/components/ReviewDetailsRow'
import { namePartTypeKeys } from '../../shared/utils/helpers'

/**
 * Displays the Essential Information Review Mode inside a Card component.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.person - Person object containing essential information
 * @returns {JSX.Element} The rendered DataBlocks with review mode information
 */
const EssentialInformationReview = ({ person }) => {
  const { t } = useTranslation()

  // Extract names
  const names = getNestedSubelementsByType(person, 'NAME') || []

  // Extract personal details using DRY utility
  const { value: sexValue } = getFieldValue(person, 'SEX_CODE')
  const { value: raceValue } = getFieldValue(person, 'RACE_OR_COLOR')
  const { value: ageValue } = getFieldValue(person, 'AGE')

  const hasPersonalDetails = sexValue || raceValue || ageValue

  return (
    <FlowGrid orientation="vertical" columnCount={1} gutters="xs">
      {names.map((name) => (
        <React.Fragment key={`name-${name.id}`}>
          <DataBlock
            heading={name.type?.primaryText || t('essential-info-name-default', 'Name')}
            data={<ReviewDetailsRow person={name} fieldTypesArray={namePartTypeKeys} />}
          />
        </React.Fragment>
      ))}

      {hasPersonalDetails && (
        <DataBlock
          heading={t('essential-info-personal-details', 'Personal Details')}
          data={<ReviewDetailsRow person={person} fieldTypesArray={['AGE', 'SEX_CODE', 'RACE_OR_COLOR']} />}
        />
      )}
    </FlowGrid>
  )
}

EssentialInformationReview.propTypes = {
  person: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
}

export default EssentialInformationReview
